module.exports = "/_next/static/images/567b38d51c9955eeacabae901bb84b53-bill-filled-package.png";